import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {AxiosResponse} from "axios";
import {Employee} from "../../../../declerations/server/role_models";
import {axiosFlexInstance} from "../../../BackofficeApiManager";

type Variables = {
  agentEmail: string | undefined;
};

type Data = Employee;

const getResolutionExpertByEmail = async (variables: Variables): Promise<Data> => {
  if (!variables.agentEmail) {
    // @ts-ignore
    return;
  }
  const response = await axiosFlexInstance.get<Data, AxiosResponse<Data>>(
    `/rex-management/employees/${variables.agentEmail}?expand=roles`
  );
  return response.data;
};

export const useGetResolutionExpertByEmail = (
  variables: Variables,
  options?: BaseQueryOptions<Data, string>
): BaseUseQueryResult<Data> => {
  return useBaseQuery<Data, Variables>(["rex"], getResolutionExpertByEmail, variables, options);
};
